import _ from 'lodash'
import { BehaviorSubject } from 'rxjs'
import { local } from './local-json'

/** Wraps stream values in a mutation checker.
 *
 * Sorry about how it looks in the DevTools scope inspector, but _.cloneDeep unwraps it.
 * TODO https://www.mattzeunert.com/2016/02/19/custom-chrome-devtools-object-formatters.html
 *
 */

export class ImmutableBehaviorSubject<T> extends BehaviorSubject<T> {
  constructor(value: T) {
    super(value)
  }
  next (value: T) {
    const isDev = ['localhost', 'development'].includes(process.env.SWARM_ENV) && local('verboseValidationErrors')
    if (!isDev) return super.next(value)
    return super.next(makeImmutableProxy(value))
  }
}

const makeImmutableProxy = (value) => {
  if (!_.isObject(value)) return value
  if (_.isPlainObject(value)) return ImmutableProxy(_.mapValues(value, makeImmutableProxy))
  if (_.isArray(value)) return ImmutableProxy(_.map(value, makeImmutableProxy))

  // unknown object type
  return value
}
const ImmutableProxy = (value) => new Proxy(value, {
  set: (target, p, value) => {
    const isLocal = process.env.SWARM_ENV == 'localhost' && local('verboseValidationErrors')
    if (isLocal) {
      const msg = `Tried to set ${String(p)} to ${JSON.stringify(value)} on immutable target ${JSON.stringify(target)}.  Consider using _.cloneDeep.`
      console.error(msg)
      debugger // You can inspect the call stack from here to find the offender or unpause debugger for more detailed trace.
      return false
    } else {
      const msg = `Set ${String(p)} to ${JSON.stringify(value)} on immutable target ${JSON.stringify(target)}.  Consider using _.cloneDeep.`
      console.warn(msg)
      _.set(target, p, value)
      return true
    }
  }
})